// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1H7eL","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3UZwb","obliqueLine":"membershipbadge_obliqueLine__3acir"};